var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52177 4L14.8 4.26338C16.3331 4.31884 17.6935 5.28692 18.2811 6.7404L20.4331 12.0643C20.934 13.3032 20.7992 14.7167 20.0739 15.8327L17.3166 20.075C18.9491 22.4192 23.3894 27.9116 28.091 31.1266L31.5968 28.969C32.4878 28.4206 33.5546 28.2578 34.5628 28.5162L41.5322 30.3034C43.3858 30.7788 44.6348 32.5564 44.4884 34.5104L44.041 40.477C43.8838 42.5708 42.1702 44.2138 40.136 43.9774C13.2849 40.8552 -2.46113 3.99994 7.52177 4Z",
    stroke: "#3C4043",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.3b0623ab6a6c14082d8db113a1e3ecbd.svg";
export { ForwardRef as ReactComponent };